import React, { useState, useEffect } from 'react';
import './index.css'
import { connect } from 'react-redux';
import { IoMdSend } from 'react-icons/io'
import { smsConfirm, smsToken } from '../../Actions/login';
import { toast } from 'react-toastify';


export function Popup({ close, userValidated, tokenAuthApi }) {
  const [timerStatus, setTimerStatus] = useState(true);
  const [seconds, setSeconds] = useState(0);
  const [alterString, setAlterString] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [user, setUser] = useState([]);
  const [numberPhone, setNumberPhone] = useState('');

  useEffect(() => {
    const getUser = localStorage.getItem("boleto@dataUser")
    if (getUser) {
      setUser(JSON.parse(getUser));
    }
  }, [])

  useEffect(() => {

    if (seconds != 0) {
      setTimeout(() => {
        setSeconds(state => state - 1)
      }, 1000)
    }
    else {
      setTimerStatus(true)
    }



  }, [seconds])

  useEffect(() => {
    if (user.FONE) {
      let number;
      if (user.FONE.length === 8) {
        number = 9 + String(user.FONE);
      } else {
        number = String(user.FONE);
      }
      setNumberPhone(user.DDD + number)
    }
  }, [user])


  async function btnSubmit() {
    if (!alterString) {
      toast.warn("Envie o código de verificação")
      return
    }

    const authCode = await smsConfirm(numberPhone, inputValue, tokenAuthApi)
    if (authCode) {
      userValidated()
      toast.success("Telefone verificado com sucesso!")
    } else {
      toast.warn("Código de verificação errado")
    }
  }

  function btnChange() {
    toast.info("Entre em contato com uma de nossas filiais para alterar seu número de telefone!")
  }

  function btnSms() {
    let number;
    if (user.FONE.length === 8) {
      number = 9 + String(user.FONE);
    } else {
      number = String(user.FONE);
    }
    toast.success("Código enviado com sucesso")
    const DDDandPhone = user.DDD + number
    setAlterString(true)
    setSeconds(60)
    smsToken(DDDandPhone, tokenAuthApi);
    setTimerStatus(false)
  };

  return (
    <div className='popup'>
      <div className='popupBackground'></div>
      <div className='popupContent'>
        <a className='popupClose' onClick={close}>+</a>
        <h1 className='tittle'>Valide o seu número celular</h1>
        <p>Envie o código para o número com o final ∗∗{numberPhone.substring(9, 11)} para ser <br />feita a validação do seu cadastro.</p>
        <button
          onClick={btnChange}
          type='button'
          className='btnChange'
          placeholder='Esse não é meu numero'
        >Este não é meu telefone</button>
        <div className='authentication'>
          <input
            id='codeSMS'
            onChange={(e) => setInputValue(e.target.value)}
            type='text'
            maxLength={6}
            placeholder='Código de verifícação'
            required
          >
          </input>

          <button
            onClick={btnSubmit}
            type='button'>
            <IoMdSend size={35} />
          </button>
          <br />
        </div>
        <br />
        <div>

          {!timerStatus ?
            <button
              disabled
              className='btn_Timer'
              type='button'
            >
              Aguarde {seconds} segundos para reenviar
            </button>
            :
            <button
              className={!alterString ? 'btn_smscode' : 'btn_smscode_reenviar'}
              onClick={btnSms}
              type='button'>

              {alterString ? "Reenviar SMS" : "Enviar SMS"}
            </button>
          }
        </div>
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/Components/Popup/index.js